import './HealthRing.css';

export interface HealthRingProps {
  /** Pre-formatted score, or "—" when there is no score. */
  value: string;
  /** Translated caption, e.g. "Health score". */
  label: string;
  /** Translated verdict, read out with the score (e.g. "No data yet"). */
  statusLabel?: string;
  /**
   * Hide the caption inside the ring (it stays in the accessible name). For small rings, where
   * the caption does not fit and the caller shows it next to the ring instead.
   */
  hideCaption?: boolean;
}

/** Decorative ring with the score; all strings arrive translated. */
export function HealthRing({ value, label, statusLabel, hideCaption = false }: HealthRingProps) {
  const accessibleName = [label, value === '—' ? undefined : value, statusLabel].filter(Boolean).join(', ');
  return (
    <div className="rg-health-ring" role="img" aria-label={accessibleName}>
      <div className="rg-health-ring__inner" aria-hidden="true">
        <strong>{value}</strong>
        {!hideCaption && <span>{label}</span>}
      </div>
    </div>
  );
}
